// ============================================
// Path: /frontend/src/pages/TermsPage.jsx
// Purpose: Terms of Service page - static legal content display
// ============================================

// ========================================
// IMPORTS
// ========================================
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';

// ========================================
// MAIN COMPONENT
// ========================================
export default function TermsPage() {
  console.log('🎨 [TermsPage] Component mounted');

  // ========================================
  // RENDER
  // ========================================
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow container py-6 sm:py-8 md:py-12 px-4">
        <div className="max-w-4xl mx-auto">
          {/* Page Header */}
          <div className="text-left mb-4 sm:mb-6 md:mb-8">
            <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold mb-1 sm:mb-2">
              Terms of Service
            </h1>
            <p className="text-xs sm:text-sm md:text-base text-muted-foreground">
              Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-6 sm:space-y-8">
            {/* Section 1 */}
            <section className="bg-muted/40 rounded-lg p-3 sm:p-4 md:p-6">
              <h2 className="text-base sm:text-lg md:text-xl font-semibold mb-2 sm:mb-3 text-foreground">
                1. Introduction
              </h2>
              <p className="text-xs sm:text-sm md:text-base text-foreground/80 leading-relaxed">
                Welcome to MotoHome Finder. By accessing our website, you agree to be bound by these Terms of Service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws.
              </p>
            </section>

            {/* Section 2 */}
            <section className="bg-muted/40 rounded-lg p-3 sm:p-4 md:p-6">
              <h2 className="text-base sm:text-lg md:text-xl font-semibold mb-2 sm:mb-3 text-foreground">
                2. Use License
              </h2>
              <p className="text-xs sm:text-sm md:text-base text-foreground/80 leading-relaxed">
                Permission is granted to temporarily download one copy of the materials (information or software) on MotoHome Finder's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title.
              </p>
            </section>

            {/* Section 3 */}
            <section className="bg-muted/40 rounded-lg p-3 sm:p-4 md:p-6">
              <h2 className="text-base sm:text-lg md:text-xl font-semibold mb-2 sm:mb-3 text-foreground">
                3. Disclaimer
              </h2>
              <p className="text-xs sm:text-sm md:text-base text-foreground/80 leading-relaxed">
                The materials on MotoHome Finder's website are provided on an 'as is' basis. MotoHome Finder makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
              </p>
            </section>

            {/* Section 4 */}
            <section className="bg-muted/40 rounded-lg p-3 sm:p-4 md:p-6">
              <h2 className="text-base sm:text-lg md:text-xl font-semibold mb-2 sm:mb-3 text-foreground">
                4. Limitations
              </h2>
              <p className="text-xs sm:text-sm md:text-base text-foreground/80 leading-relaxed">
                In no event shall MotoHome Finder or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on MotoHome Finder's website.
              </p>
            </section>

            {/* Section 5 */}
            <section className="bg-muted/40 rounded-lg p-3 sm:p-4 md:p-6">
              <h2 className="text-base sm:text-lg md:text-xl font-semibold mb-2 sm:mb-3 text-foreground">
                5. Governing Law
              </h2>
              <p className="text-xs sm:text-sm md:text-base text-foreground/80 leading-relaxed">
                These terms and conditions are governed by and construed in accordance with the laws of Kenya and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.
              </p>
            </section>
          </div>

          {/* Footer Note */}
          <div className="mt-6 sm:mt-8 pt-4 sm:pt-6 border-t border-border">
            <p className="text-[10px] sm:text-xs md:text-sm text-muted-foreground text-center">
              If you have any questions about these Terms of Service, please contact us.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}